import fetchJSON from '@api/api_helper';


const url = (labelKey) => `/api/v4/labels/${labelKey}`;
const moveUrl = (labelKey) => `/api/v4/labels/${labelKey}/move`;

// update name or position, NOT path (depth)
// example options: { name: 'Sale Team', position: 3 }
export const update = (labelKey, options) => (
  fetchJSON(url(labelKey), {
    method: 'PUT',
    body: {
      data: {
        attributes: {
          ...options
        }
      }
    }
  }).catch(async (response) => { throw (await response.json()); })
);


export const destroy = (labelKey) => (
  fetchJSON(url(labelKey), {
    method: 'DELETE'
  }).catch(async (response) => { throw (await response.json()); })
);


// update path (depth)
// parent_key = null will move label to top level
export const move = (labelKey, parent_key) => (
  fetchJSON(moveUrl(labelKey), {
    method: 'PUT',
    body: {
      data: {
        attributes: {
          parent_key
        }
      }
    }
  }).catch(async (response) => { throw (await response.json()); })
);
